<div class="row d-flex mt-20">
    <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4 d-none d-sm-none d-md-block">
        <div class="row mb-4 d-block">
            <div class="col-12">
                <div class="card card-way shadow cursor-pointer" [class.shadow]="wayIndex == 0" [class.bg-white]="wayIndex == 0" [class.bg-grey]="wayIndex != 0" (click)="gotoWay(1)">
                    <div class="card-body d-flex align-items-center">
                        <img loading="lazy" src="assets/components/ways-to-study/icn-campus-classes.webp" style="width: 52px;" class="mr-4" /> <h5 class="m-0">Campus Classes</h5>
                    </div>
                    <div class="active-line" [class.d-none]="wayIndex != 0"></div>
                </div>
            </div>
        </div>

        <div class="row mb-4 d-block">
            <div class="col-12">
                <div class="card card-way shadow cursor-pointer" [class.shadow]="wayIndex == 1" [class.bg-white]="wayIndex == 1" [class.bg-grey]="wayIndex != 1" (click)="gotoWay(2)">
                    <div class="card-body d-flex align-items-center">
                        <img loading="lazy" src="assets/components/ways-to-study/icn-virtual-classes.webp" style="width: 52px;" class="mr-4" /> <h5 class="m-0">Virtual Classes</h5>
                    </div>
                    <div class="active-line" [class.d-none]="wayIndex != 1"></div>
                </div>
            </div>
        </div>

        <div class="row mb-4 d-block">
            <div class="col-12">
                <div class="card card-way shadow cursor-pointer" [class.shadow]="wayIndex == 2" [class.bg-white]="wayIndex == 2" [class.bg-grey]="wayIndex != 2" (click)="gotoWay(3)">
                    <div class="card-body d-flex align-items-center">
                        <img loading="lazy" src="assets/components/ways-to-study/icn-online-classes.webp" style="width: 52px;" class="mr-4" /> <h5 class="m-0">Online Classes</h5>
                    </div>
                    <div class="active-line" [class.d-none]="wayIndex != 2"></div>
                </div>
            </div>
        </div>

        <div class="row d-block">
            <div class="col-12">
                <div class="card card-way shadow cursor-pointer" [class.shadow]="wayIndex == 3" [class.bg-white]="wayIndex == 3" [class.bg-grey]="wayIndex != 3" (click)="gotoWay(4)">
                    <div class="card-body d-flex align-items-center">
                        <img loading="lazy" src="assets/components/ways-to-study/icn-home-study-online.webp" style="width: 52px;" class="mr-4" /> <h5 class="m-0">Home Study Online</h5>
                    </div>
                    <div class="active-line" [class.d-none]="wayIndex != 3"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-8">
        <swiper
        [config]="standardConfig"
        (swiper)="onWaySwiper($event)"
        (slideChange)="onWaySlideChange()"
        class="w-100"
        >
            <ng-template swiperSlide class="w-100 px-2">
                <div class="card shadow-xs">
                    <img loading="lazy" src="assets/components/ways-to-study/campus-classes-bg.webp" class="card-img-top" />
                    <div class="card-body" style="padding: 1.5rem;">

                        <div class="d-flex d-sm-flex d-md-none align-items-center" style="margin-bottom: 2rem;">
                            <img loading="lazy" src="assets/img/home/way-1.webp" style="width: 84px;" class="mr-4" /> <h3 class="m-0 text-dark">Campus Classes</h3>
                        </div>

                        <p class="font-size-16 text-left text-sm-left text-md-center text-dark mb-0"><strong>Campus Classes</strong> Enjoy face-to-face tuition in Sandton and Cape Town with our most popular lecturers. Seats are limited.</p>
                        <p class="text-left text-sm-left text-md-center mb-0">
                            <button class="btn text-primary font-size-16 font-weight-bold px-0">Learn More <img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg"></button>
                        </p>
                    </div>
                </div>
            </ng-template>
            <ng-template swiperSlide class="w-100 px-2">
                <div class="card shadow-xs">
                    <img loading="lazy" src="assets/components/ways-to-study/virtual-classes-bg.webp" class="card-img-top" />
                    <div class="card-body" style="padding: 1.5rem;">
                        <div class="d-flex d-sm-flex d-md-none align-items-center" style="margin-bottom: 2rem;">
                            <img loading="lazy" src="assets/img/home/way-2.webp" style="width: 84px;" class="mr-4" /> <h3 class="m-0 text-dark">Virtual Classes</h3>
                        </div>

                        <p class="font-size-16 text-left text-sm-left text-md-center text-dark mb-0"><strong>Virtual Classes</strong> Now everybody can sit in the front row of class. Enjoy live streaming IBTC lectures from the comfort of your own home.</p>
                        <p class="text-left text-sm-left text-md-center mb-0"><button class="btn text-primary font-size-16 font-weight-bold px-0">Learn more <img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg"></button></p>
                    </div>
                </div>
            </ng-template>
            <ng-template swiperSlide class="w-100 px-2">
                <div class="card shadow-xs">
                    <img loading="lazy" src="assets/components/ways-to-study/online-classes-bg.webp" class="card-img-top" />
                    <div class="card-body" style="padding: 1.5rem;">
                        <div class="d-flex d-sm-flex d-md-none align-items-center" style="margin-bottom: 2rem;">
                            <img loading="lazy" src="assets/img/home/way-3.webp" style="width: 84px;" class="mr-4" /> <h3 class="m-0 text-dark">Online Classes</h3>
                        </div>

                        <p class="font-size-16 text-left text-sm-left text-md-center text-dark mb-0"><strong>Online Classes</strong>  Follow a fast-paced 6-8 week schedule with access to video lectures, online tests, question debriefs, tutors and classmates. Our Online Classes have monthly start dates.</p>
                        <p class="text-left text-sm-left text-md-center mb-0"><button class="btn text-primary font-size-16 font-weight-bold px-0">Learn more <img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg"></button></p>
                    </div>
                </div>
            </ng-template>
            <ng-template swiperSlide class="w-100 px-2">
                <div class="card shadow-xs">
                    <img loading="lazy" src="assets/components/ways-to-study/home-study-online-bg.webp" class="card-img-top" />
                    <div class="card-body" style="padding: 1.5rem;">
                        <div class="d-flex d-sm-flex d-md-none align-items-center" style="margin-bottom: 2rem;">
                            <img loading="lazy" src="assets/img/home/way-4.webp" style="width: 84px;" class="mr-4" /> <h3 class="m-0 text-dark">Home Study Online</h3>
                        </div>

                        <p class="font-size-16 text-left text-sm-left text-md-center text-dark mb-0"><strong>Home Study Online</strong> Take your Home Study to the next level with access to video lectures and online tests. Start at any time. Set your own pace.</p>
                        <p class="text-left text-sm-left text-md-center mb-0"><button class="btn text-primary font-size-16 font-weight-bold px-0">Learn more <img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg"></button></p>
                    </div>
                </div>
            </ng-template>
        </swiper>
    </div>
</div>